var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextsecuritydisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Fri Jan  5 19:35:57 2018\n By www-data\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "textsecuritydisc",
    horizAdvX: 800
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "textsecuritydisc",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 2000,
    panose1: "2 0 5 3 0 0 0 0 0 0",
    ascent: 2000,
    descent: 0,
    bbox: "66 0 700 1333",
    underlineThickness: 0,
    underlinePosition: 20,
    unicodeRange: "U+0001-0001"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    d: "M66 0v1333h530v-1333h-530zM132 66h398v1201h-398v-1201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    d: "M66 0v1333h530v-1333h-530zM132 66h398v1201h-398v-1201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02FF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02FE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02FD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02FC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02FB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02FA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02F0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02EF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02EE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02ED",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02EC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02EB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02EA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02E0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02DF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02DE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02DD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02DC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02DB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02DA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02D0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02CF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02CE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02CD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02CC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02CB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02CA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02C0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02BF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02BE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02BD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02BC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02BB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02BA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02B0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02AF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02AE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02AD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02AC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02AB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02AA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u02A0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u029F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u029E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u029D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u029C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u029B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u029A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0299",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0298",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0297",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0296",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0295",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0294",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0293",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0292",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0291",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0290",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u028F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u028E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u028D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u028C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u028B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u028A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0289",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0288",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0287",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0286",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0285",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0284",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0283",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0282",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0281",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0280",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u027F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u027E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u027D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u027C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u027B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u027A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0279",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0278",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0277",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0276",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0275",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0274",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0273",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0272",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0271",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0270",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u026F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u026E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u026D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u026C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u026B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u026A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0269",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0268",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0267",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0266",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0265",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0264",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0263",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0262",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0261",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0260",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u025F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u025E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u025D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u025C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u025B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u025A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0259",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0258",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0257",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0256",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0255",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0254",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0253",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0252",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0251",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0250",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u024F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u024E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u024D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u024C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u024B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u024A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0249",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0248",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0247",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0246",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0245",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0244",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0243",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0242",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0241",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0240",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u023F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u023E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u023D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u023C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u023B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u023A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0239",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0238",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0237",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0236",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0235",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0234",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0233",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0232",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0231",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0230",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u022F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u022E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u022D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u022C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u022B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u022A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0229",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0228",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0227",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0226",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0225",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0224",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0223",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0222",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0221",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0220",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u021F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u021E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u021D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u021C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u021B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u021A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0219",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0218",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0217",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0216",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0215",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0214",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0213",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0212",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0211",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0210",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u020F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u020E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u020D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u020C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u020B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u020A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0209",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0208",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0207",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0206",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0205",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0204",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0203",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0202",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0201",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0200",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01FF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01FE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01FD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01FC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01FB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01FA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01F0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01EF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01EE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01ED",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01EC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01EB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01EA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01E0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01DF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01DE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01DD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01DC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01DB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01DA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01D0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01CF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01CE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01CD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01CC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01CB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01CA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01C0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01BF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01BE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01BD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01BC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01BB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01BA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01B0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01AF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01AE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01AD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01AC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01AB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01AA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u01A0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u019F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u019E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u019D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u019C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u019B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u019A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0199",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0198",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0197",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0196",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0195",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0194",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0193",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0192",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0191",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0190",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u018F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u018E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u018D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u018C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u018B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u018A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0189",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0188",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0187",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0186",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0185",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0184",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0183",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0182",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0181",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0180",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u017F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u017E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u017D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u017C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u017B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u017A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0179",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0178",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0177",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0176",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0175",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0174",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0173",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0172",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0171",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0170",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u016F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u016E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u016D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u016C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u016B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u016A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0169",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0168",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0167",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0166",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0165",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0164",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0163",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0162",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0161",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0160",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u015F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u015E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u015D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u015C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u015B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u015A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0159",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0158",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0157",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0156",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0155",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0154",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0153",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0152",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0151",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0150",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u014F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u014E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u014D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u014C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u014B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u014A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0149",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0148",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0147",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0146",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0145",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0144",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0143",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0142",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0141",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0140",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u013F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u013E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u013D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u013C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u013B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u013A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0139",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0138",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0137",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0136",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0135",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0134",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0133",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0132",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0131",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0130",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u012F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u012E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u012D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u012C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u012B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u012A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0129",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0128",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0127",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0126",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0125",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0124",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0123",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0122",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0121",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0120",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u011F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u011E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u011D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u011C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u011B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u011A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0119",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0118",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0117",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0116",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0115",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0114",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0113",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0112",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0111",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0110",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u010F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u010E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u010D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u010C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u010B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u010A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0109",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0108",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0107",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0106",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0105",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0104",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0103",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0102",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0101",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\u0100",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xFF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xFE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xFD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xFC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xFB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xFA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xF0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xEF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xEE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xED",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xEC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xEB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xEA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xE0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xDF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xDE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xDD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xDC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xDB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xDA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xD0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xCF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xCE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xCD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xCC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xCB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xCA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xC0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xBF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xBE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xBD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xBC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xBB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xBA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xB0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xAF",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xAE",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xAD",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xAC",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xAB",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xAA",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA9",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA8",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA7",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA6",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA5",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA4",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA3",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA2",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA1",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\xA0",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\x85",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "~",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "}",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "|",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "{",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "z",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "y",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "x",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "w",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "v",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "u",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "t",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "s",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "r",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "q",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "p",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "o",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "n",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "m",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "l",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "k",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "j",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "i",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "h",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "g",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "f",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "e",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "d",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "c",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "b",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "a",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "`",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "_",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "^",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "]",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\\\\\\\\",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "[",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "Z",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "Y",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "X",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "W",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "V",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "U",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "T",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "S",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "R",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "Q",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "P",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "O",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "N",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "M",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "L",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "K",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "J",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "I",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "H",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "G",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "F",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "E",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "D",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "C",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "B",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "A",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "@",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "?",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: ">",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "=",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "<",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: ";",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: ":",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 9,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 8,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 7,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 6,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 5,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 4,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 3,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 2,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 1,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: 0,
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "/",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: ".",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "-",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: ",",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "+",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "*",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: ")",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "(",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "'",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "&",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "%",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "$",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "#",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\"",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "!",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: " ",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\r",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\n",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    unicode: "\t",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "disc",
    d: "M400 800zM100 800q0 -81 41 -151q40 -68 108 -108q70 -41 151 -41t151 41q68 40 108 108q41 70 41 151t-41 151q-40 68 -108 108q-70 41 -151 41t-151 -41q-68 -40 -108 -108q-41 -70 -41 -151z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextsecuritydisc);
export default __webpack_public_path__ + "static/media/textsecuritydisc.be2c6983f6c83184cdfe7a3a6f94375b.svg";
export { ForwardRef as ReactComponent };